import React from 'react';
import SmsProviders from '../../components/AdminNext/SmsProviders';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'SMS providers — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <SmsProviders />
      </HeadLessLayout>
    )
  };
}

export default action;
